export const formatWebsiteLabel = (url: string) =>
  url.replace(/^https?:\/\//i, '').replace(/\/$/, '');

export const formatAddressLines = (address: string) => {
  const parts = address
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length <= 1) {
    return [address.trim()];
  }

  const [firstLine, ...rest] = parts;
  return [firstLine, rest.join(', ')];
};

export const mergeClassNames = (
  ...classes: Array<string | false | null | undefined>
) => classes.filter(Boolean).join(' ');
